/**
 * Версия сборки клиента (FB43). `VITE_KRP_BUILD_ID` зашивает `vite build` (коммит); тот же коммит шлюз
 * приписывает к КАЖДОМУ ответу сервера заголовком `X-Client-Build`. Клиент сравнивает свой
 * идентификатор с названным сервером: отличается — вышла новая сборка. Опроса по таймеру нет (`serverBuild.ts`).
 * Локально (`vite`, тесты) идентификатора нет — проверка обновлений выключена.
 */
export const BUILD_ID: string | undefined = import.meta.env.VITE_KRP_BUILD_ID

/** Сокращённый git sha: клиент и шлюз берут разное число знаков одного и того же коммита. */
const HEX_SHA = /^[0-9a-f]{7,64}$/i

/** Один ли это коммит: равные строки либо один hex-sha — начало другого. */
function sameBuild(left: string, right: string): boolean {
  if (left === right) return true
  if (!HEX_SHA.test(left) || !HEX_SHA.test(right)) return false
  const a = left.toLowerCase()
  const b = right.toLowerCase()
  return a.startsWith(b) || b.startsWith(a)
}

/** Вышла ли новая сборка: свой идентификатор известен, серверный — тоже, и это разные коммиты. */
export function isNewVersion(current: string | undefined, remote: string | null | undefined): boolean {
  if (current === undefined || current === '' || remote === null || remote === undefined || remote === '') return false
  return !sameBuild(current, remote)
}
